import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { getProductPrimaryOptionId } from 'commons/productUtils';
import ProductCardImage from 'components/consumer/product-card/ProductCardPhoto/ProductCardImage';
import categoryAngles from 'commons/category-angles.json';
import getDefaultOptionData from 'commons/getDefaultOptionData';
import constructImageURLsForVariant from 'commons/constructImageURLsForVariant';
import constructHeroImageURL from 'commons/constructHeroImageURL';

const getConstructedProductImage = product => {
  let categoryImages = {};

  const productAngle = categoryAngles[product.type.name.toLowerCase()]
    ? categoryAngles[product.type.name.toLowerCase()]
    : 1;

  categoryImages = constructHeroImageURL(product, null, productAngle, true);

  const { finalSku, optionName } = getDefaultOptionData(product);

  categoryImages = {
    ...categoryImages,
    ...constructImageURLsForVariant(
      product.id,
      finalSku,
      product.name,
      optionName,
      productAngle,
      null,
      true
    ),
  };

  return categoryImages;
};

class ProductImage extends React.Component {
  state = {
    imageLoaded: false,
  };

  get image() {
    return (
      get(this.props, 'images.0.url') || get(this, 'hero_images_min.0.url')
    );
  }

  get options() {
    if (!this.props.options.length) return null;

    return getProductPrimaryOptionId(this.props.options);
  }

  setImageLoaded = () => {
    this.setState(() => ({ imageLoaded: true }));
  };

  categoryImages = () => {
    if (this.props.slug?.endsWith('-modular')) {
      return {
        transparent_config_image: this.props.images.length
          ? this.props.images[0].url
          : this.props.hero_images_min[0].url,
      };
    }
    return getConstructedProductImage(this.props);
  };

  render() {
    return (
      <ProductCardImage
        image={this.image}
        imageLoaded={this.state.imageLoaded}
        productImages={this.categoryImages()}
        setImageLoaded={this.setImageLoaded}
        productImageOptionTypeId={this.options}
        forceFallback={this.props.forceFallback}
        layout={this.props.layout}
      />
    );
  }
}

ProductImage.propTypes = {
  slug: PropTypes.string,
  layout: PropTypes.string,
  forceFallback: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
    })
  ),
  hero_images_min: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
    })
  ),
};

export default ProductImage;
